import { ref, watch, computed } from '@vue/composition-api';
import axios from '@axios';
import useAuth from '@/auth/useAuth';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useSurveyList(isTemplate) {
  const refDocumentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', sortable: false, thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'label', label: i18nT(`Title`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'type', label: i18nT(`Type`), sortable: true },
    { key: 'created', label: i18nT(`Created`), sortable: true },
    { key: 'updated', label: i18nT(`Updated`), sortable: true },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ];
  const perPage = ref(10);
  const totalDocuments = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('');
  const isSortDirDesc = ref(true);
  const questionType = ref('');
  const group = ref(null);
  const questions = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value ?
      refDocumentListTable.value.localItems.length :
      0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    };
  });

  const refetchData = () => {
    refDocumentListTable.value.refresh();
  };

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      questionType,
      group,
    ],
    () => {
      refetchData();
    }
  );

  const fetchQuestions = (ctx, callback) => {
    const curWorkspace = useAuth.getCurWorkspace();

    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      company_id: curWorkspace.Id,
      search: searchQuery.value
    };

    if (isTemplate) {
      params.templates = 1;
    }

    if (questionType.value != null && questionType.value !== '') {
      params['filters[type]'] = questionType.value;
    }
    if (group.value != null) {
      params['filters[group]'] = group.value;
    }

    axios
      .get(`surveys/questions`, {
        params,
      })
      .then(({ data }) => {
        questions.value = data.data.questions;
        callback(data.data.questions);
        totalDocuments.value = data.data.pagination.records_count;
      });
  };

  return {
    fetchQuestions,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    questionType,
    group,
    questions,
    refetchData,
  };
}